<template>
    <div class="fanGraphSummary-header">
        <div class="cad custom-btn" @click="openCadTable"
             :class="{active: isActive, no_results: !isActive && this.similarFans == 0}">
            CAD
        </div>
        <div class="text-container">
            <h1>{{translate("collective_characteristics")}}</h1>
            <p v-if="offerView" class="fan-type-model">{{this.$store.state.activeFun.type}}
                {{this.$store.state.activeFun.model}}</p>
            <div class="custom-select">
                <div v-for="fan in fans"
                     v-if="fan.isActive"
                     class="selected_item"
                     @click.stop.prevent="toggleExpandOfCustomSelect">
                    <span class="value" v-html="fan.model"/>
                    <span class="icon-bottom_arrow"/>
                </div>
                <div class="items-container">
                    <div class="item"
                         v-for="fan in fans"
                         v-if="!fan.isActive"
                         @click.stop.prevent="toggleExpandOfCustomSelect($event), selectFanRowAsActiveInFansTable(fan)"
                         v-html="fan.model">
                    </div>
                </div>
            </div>
        </div>
        <div class="chart_grids-container" :class="{hidden: isActive || this.similarFans == 0}">
            <div class="custom-btn" :class="isActiveGrid(100, 100) ? 'active' : ''"
                 v-on:click="setChartGrid(100, 100)">
                <span class="icon-box"/>
            </div>
            <div class="custom-btn"
                 :class="isActiveGrid(60, 50) ? 'active' : ''"
                 v-on:click="setChartGrid(60, 50)">
                <span class="icon-double_criss_cross"/>
            </div>
            <div class="custom-btn"
                 :class="isActiveGrid(40, 25) ? 'active' : ''"
                 v-on:click="setChartGrid(40, 25)">
                <span class="icon-triple_criss_cross"/>
            </div>
        </div>
    </div>
</template>

<script>
    import CadTable from "./CadTable";
    import Vue from 'vue'

    export default {
        name: "FanGraphSummaryHeader",
        components: {CadTable},
        props: {
            offerView: {
                default: false
            }
        },
        data() {
            return {
                isActive: false,
                renderComponent: true,
                componentKey: 0,
                fans: [],
                similarFans: 0,
            }
        },

        methods: {

            printElementInfo(element) {
                if (this.$store.state.selectedSecondStepElement.multiple_fans == 1 && element.data['number_of_fans'] && element.data['number_of_fans'] > 0) {
                    return element.data['number_of_fans'];
                } else {
                    return null;
                }
            },

            manageSelectedFan() {
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            },

            openCadTable() {
                this.$emit('openCadHeader');
                this.isActive = !this.isActive;
            },

            isActiveGrid(xStep, yStep) {
                if (this.$store.state.graphMeshSettings && this.$store.state.graphMeshSettings.x && this.$store.state.graphMeshSettings.x.step && this.$store.state.graphMeshSettings.x.step == xStep && this.$store.state.graphMeshSettings.y.step == yStep)
                    return true;
                else
                    return false;
            },
            setChartGrid(xStep, yStep) {
                this.$store.commit('changeGridSetting', {x: xStep, y: yStep});
            },

            selectFanRowAsActiveInFansTable(fan) {
                let selectedWorkPointCopy = {
                    workPointPressure: 0,
                    workPointPerformance: 0,
                    workPointPerformanceHour: 0
                };

                if (this.$store.state.selectedWorkPoint) {
                    selectedWorkPointCopy.workPointPressure = this.$store.state.selectedWorkPoint.workPointPressure;
                    selectedWorkPointCopy.workPointPerformance = this.$store.state.selectedWorkPoint.workPointPerformance;
                    selectedWorkPointCopy.workPointPerformanceHour = this.$store.state.selectedWorkPoint.workPointPerformanceHour;
                }

                Vue.set(this.$store.state.activeFun, 'count', fan.count);
                this.fans = this.getFansTableData();
                this.similarFans = this.countSimilarFans();
                this.componentKey = this.$store.state.activeFun.count;
                this.$store.state.setWorkPointWhenFanHandlerFired = true;
                this.$store.state.selectFanHandler++;

                if (this.$store.state.selectedWorkPoint) {
                    this.$store.state.selectedWorkPoint.workPointPressure = selectedWorkPointCopy.workPointPressure;
                    this.$store.state.selectedWorkPoint.workPointPerformance = selectedWorkPointCopy.workPointPerformance;
                    this.$store.state.selectedWorkPoint.workPointPerformanceHour = selectedWorkPointCopy.workPointPerformanceHour;
                    this.$store.state.selectWorkPointHandler++;
                }
            },

            getFansTableData() {
                let mf = this.$store.state.activeFun.count;
                let fans = [];

                if (this.$store.state.selectedSecondStepElement.multiple_fans == 1 && this.$store.state.activeFun && this.$store.state.fansTableData.FanTableRef && this.$store.state.fansTableData.FanTableRef.allFilteredData.length > 0) {
                    fans.push({
                        id: this.$store.state.activeFun.id,
                        isActive: (!this.$store.state.activeFun || !this.$store.state.activeFun.count || this.$store.state.activeFun.count < 2 || !this.$store.state.activeFun.params.number_of_fans || this.$store.state.activeFun.params.number_of_fans < 2),
                        model: this.$store.state.activeFun.model,
                        count: 1
                    });

                    if (this.$store.state.activeFun.params.number_of_fans && this.$store.state.activeFun.params.number_of_fans > 1)
                        fans.push({
                            id: this.$store.state.activeFun.id,
                            isActive: (this.$store.state.activeFun && this.$store.state.activeFun.count && this.$store.state.activeFun.count > 1),
                            model: this.$store.state.activeFun.model + " (" + this.$store.state.activeFun.params.number_of_fans + ")",
                            count: this.$store.state.activeFun.params.number_of_fans
                        });
                }

                return fans;
            },

            countSimilarFans() {
                this.manageSelectedFan();

                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            },

            toggleExpandOfCustomSelect(e) {
                let target = e.target;

                document.querySelectorAll('.custom-select').forEach((select) => {

                    select.classList.remove("expanded");
                });

                while (target instanceof Element) {

                    if (target.classList.contains('selected_item')) {

                        target.parentElement.classList.toggle("expanded");
                        return;

                    } else if (
                        target.classList.contains('value') ||
                        target.classList.contains('icon-bottom_arrow')) {

                        target.parentElement.parentElement.classList.toggle("expanded");
                        return;

                    } else if (target.classList.contains('items-container')) {

                        target.parentElement.classList.remove("expanded");
                        return;

                    } else if (target.classList.contains('item')) {

                        target.parentElement.parentElement.classList.remove("expanded");
                        return;

                    } else {
                        return;
                    }
                }
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
        },
        computed: {
            countSimilarFansComp() {
                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            },

            selectedFan() {
                return this.$store.state.selectFanHandler;
            },
        },

        watch: {
            selectedFan() {
                this.fans = this.getFansTableData();
                this.similarFans = this.countSimilarFans();
            },
            countSimilarFansComp() {
                this.fans = this.getFansTableData();
                this.similarFans = this.countSimilarFans();
            }
        },

        mounted() {
            this.fans = this.getFansTableData();
            this.similarFans = this.countSimilarFans();
        }
    }
</script>